import { queryOptions } from "@-/com.npmjs.tanstack__react-query";
import { loadHanziScriptConverters } from "#hanzi-script-converters";

const HANZI_SCRIPT_CONVERTERS_QUERY_KEY = ["hanziScriptConverters"] as const;

/** Lazily load the shared dictionaries without adding client dependencies to Worker imports. */
export function getHanziScriptConvertersQueryOptions() {
  return queryOptions({
    // Do not pass TanStack's per-fetch context to the zero-argument memoization key.
    queryFn: () => loadHanziScriptConverters(),
    queryKey: HANZI_SCRIPT_CONVERTERS_QUERY_KEY,
    staleTime: Infinity,
  });
}
